<template>
  <article class="dashboard__notes">

      <div class="d-lg-flex justify-content-lg-between">
        

        <div class="dashboard__title mt-lg-0 d-lg-flex align-items-lg-center">
          <h1 class="title--1 mr-lg-3 mb-lg-0" v-html="'System Messages'"/>
          <p class="overview__text" v-html="'All messages'"/>
        </div>

      </div>

      <div class="row detail__content__notes" style="max-height:500px;">
        <div class="col-md-3">
          <div class="card" style="width: 100%;">
            <ul class="list-group list-group-flush" id="inbox-list">
              <h6 class="font-weight-light p-5 text-center" v-if="!messages.length">No messages to show</h6>
              <li class="list-group-item"
                style="cursor: pointer"
                v-bind:style="(selected_message == index) ? 'background-color: #008AD8; color: #fff' : ''"  
                @click="seeMessage(index)" v-for="(item, index) in messages" 
                :key="index">{{ (item.subject.length > 100) ?  item.subject.slice(16, length) : item.subject}} <a class="font-weight-light float-right">{{item.created_at_formatted}}</a></li>
            </ul>
          </div>
        </div>
        <div class="col-md-8">
          <div class="shadow-none p-3 mb-5 bg-light rounded">
            <p
              style="height: 120px;"
              disabled
              id="textarea"
              rows="7"
              v-html="message"
            >
            </p>
          </div>
        </div>
      </div>

    </article>
</template>

<script>
import eventBus from '../../plugins/eventBus';
import { getSocket } from '../../plugins/socket';


export default {
    props: [
        'rest_api'
    ],
    name: 'MessageComponent',
    data()
    {
        return {
            messages: [],
            message: '',
            selected_message: 0
        }
    },
    methods:{
      fill_data(data)
      {
          this.messages = data.messages.filter(item => item.show_on_web_dashboard)
          if(this.messages.length)
          {
              this.message = this.messages[0].message
          }
          this.$emit('showMessages', this.messages.length > 0)
      },
      seeMessage(index)
      {
        
        this.selected_message = index
        this.message = this.messages[index].message
      }

    },
    computed: {
      messages_length() {
        return this.messages.length
      }
    },
    mounted()
    {
        eventBus.$on('message_dashboard', () => 
        {
            getSocket().on('message-dashboard', (data) => { 
                let message = data.message

                if(message.show_on_web_dashboard)
                {
                    const foundIndex = this.messages.findIndex(item => item.id === message.id)

                    if(foundIndex > -1)
                    {
                        if(message.sent_on && message.status)
                        {
                            this.messages.splice(foundIndex, 1, message)
                        }
                        else
                        {
                            this.messages.splice(foundIndex, 1)
                        }
                    }
                    else
                    {
                        this.messages.unshift(message)
                    }

                    if(this.messages.length)
                    {
                        if(this.messages.length > 1)
                        {
                            this.message = this.messages[this.selected_message].message
                        }
                        else
                        {
                            this.message = this.messages[0].message
                        }
                    }
                }
            })
        });
     
      this.api_request()
    }

}
</script>
